// extracted by mini-css-extract-plugin
export default {"rating":"iw-z","numberOfStars":"jw-z","count":"kw-z","barGraphSpacing":"lw-z","barGraph":"mw-z"};